<template>
  <div class="navigation">
    <nav role="navigation" id="navigation" class="tab-left">
      <router-link
        v-for="(tab, index) in tabs"
        :key="index"
        :to="tab.path"
        exact
      >
        <span>{{ tab.meta.navigationLabel }}</span>
      </router-link>
    </nav>
  </div>
</template>
<script>
export default {
  computed: {
    tabs() {
      return this.$router.options.routes;
    },
  },
  methods: {
    isActive(route) {
      return this.$route.name === route;
    },
  },
};
</script>
<style lang="scss" scoped>
.fixed {
  position: fixed;
}
.navigation {
  z-index: 100;
  background-color: color('black');
  width: 100%;
  border-bottom: 10px solid color('black-2');
  padding: 0;
  // margin-top: 10px;
}
#navigation {
  -webkit-transform: translate3d(0, 0, 0);
  position: relative;
  margin: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  max-width: 99%;
  justify-content: flex-start;
  // margin-top: 0.5em;
  // margin-bottom: -3px;

  &:after {
    content: "";
    //border-bottom: 1.5px solid rgb(0, 0, 0);
    display: block;
    flex-grow: 1;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  & > a {
    position: relative;
    //width: 3.5em;
    width: auto;
    display: inline-block;
    padding: 1em 1em 0.5em 1em;
    color: color("white");
    text-decoration: none;
    //margin: 0 -.36em;
    text-indent: -11px;
    font-weight: 500;
    font-size: 17px;
    transition: transform 150ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms;
    @include small-mobile {
      font-size: 14px;
    }
    span {
      position: relative;
      z-index: 10;
      padding: 0 8px;
    }

    &:nth-of-type(1) {
      &:before {
        z-index: 5;
      }
    }
    &:nth-of-type(2) {
      &:before {
        z-index: 4;
      }
    }
    &:nth-of-type(3) {
      &:before {
        z-index: 3;
      }
    }
    &:nth-of-type(4) {
      &:before {
        z-index: 2;
      }
    }
  }

  & > a::before {
    //border: .2em solid #fff;
    background-color: color("black-3");

    padding-bottom: 2px;
  }
  & > .router-link-exact-active {
    z-index: 108;
    &:before {
      background-color: color("black-2");
      //border: 3px solid color("white");
      border: none;
    }
  }

  a::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    //border: 3px solid color("white");
    border-bottom: 3px solid color("black-3");
    border-radius: 0.1em 0.4em 0 0;
    transform: scale(1.1, 1.3) perspective(0.5em) rotateX(5deg);
  }
}

.tab-left {
  left: 0.4em;
  a::before {
    transform-origin: bottom left;
  }
}
</style>